<template>
    <div id="privacyConsent" v-if="show" class="section-row vue-form">
        <vue-input v-if="checkbox"
            :element="checkbox" @blur="updateCheckboxValue($event.target.value)"
        />
        <p v-if="!checkbox" v-html="disclaimer"/>
    </div>
</template>
<script src="./privacy-consent-info.js"/>
